import { useLanguage } from "../i18n";
import { Reveal, Eyebrow } from "./Reveal";
import { PhotoSlot } from "./PhotoSlot";
import { PHOTOS, SHOW_PHOTOS } from "../data";

const SPACE_IMGS = [PHOTOS.sala, PHOTOS.corridor, PHOTOS.wineNiche];

export const Spaces = () => {
  const { t } = useLanguage();
  return (
    <section
      id="spazi"
      data-testid="spaces-experience-section"
      className="relative py-24 sm:py-36 grain"
      style={{ backgroundColor: "#2C0F1A" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <div className="flex items-baseline gap-5">
              <span className="font-display italic font-light text-6xl sm:text-7xl text-[#F5EFE6]/10 leading-none">
                03
              </span>
              <Eyebrow light>{t.spaces.eyebrow}</Eyebrow>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-light text-3xl sm:text-4xl lg:text-[2.75rem] tracking-tight text-[#F5EFE6]">
              {t.spaces.title}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-6 text-base leading-relaxed text-[#CBB9B0]">{t.spaces.intro}</p>
          </Reveal>
        </div>

        <div className="mt-16 space-y-16 sm:space-y-24">
          {t.spaces.items.map((s, i) => (
            <Reveal key={i} delay={0.08}>
              <div
                data-testid={`space-item-${i}`}
                className={`grid md:grid-cols-12 gap-8 md:gap-12 items-center ${
                  i % 2 === 1 ? "md:[direction:rtl]" : ""
                }`}
              >
                <div className={`${i === 1 ? "md:col-span-8" : "md:col-span-7"} [direction:ltr]`}>
                  {SHOW_PHOTOS ? (
                    <div className="group overflow-hidden aspect-[16/9]">
                      <img
                        src={SPACE_IMGS[i]}
                        alt={s.name}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
                      />
                    </div>
                  ) : (
                    <PhotoSlot className="aspect-[16/9]" />
                  )}
                </div>
                <div className={`${i === 1 ? "md:col-span-4" : "md:col-span-5"} [direction:ltr]`}>
                  <span className="font-display italic font-light text-5xl text-[#C69255]/30">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-3 font-display font-light text-2xl sm:text-3xl text-[#F5EFE6]">
                    {s.name}
                  </h3>
                  <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#CBB9B0]">
                    {s.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
